module.exports = __webpack_public_path__ + "static/bbis-commercial-2-min-1c56c8da72921a7ead075a00b9e3c001.jpg";